// Dashboard Users summary page translations (pt-BR), loaded into dashboard.users.summary by ../pt-BR.users.js
module.exports = {
  menu: "Resumo",
  title: "Resumo",
  description: "Os indicadores do antigo separador “Utilizadores”, agora com comparação e tendência.",
  kpis: {
    total: "Total",
    complete: "Perfis completos",
    incomplete: "Perfis incompletos",
    deleted: "Perfis apagados",
    active: "Ativos",
    newUsers: "Novos",
    engagement: "Engajamento médio / utilizador",
    retention: "Retenção",
  },
  info: {
    total: "Contas registadas no último dia do período.\nFonte: Firebase (índice de perfis).",
    complete: "Perfis ativos criados até ao fim do período com capa, biografia, foto, data de nascimento e género preenchidos.\nFonte: Firebase (índice de perfis).",
    incomplete: "Perfis ativos criados até ao fim do período com pelo menos um desses campos em falta.\nFonte: Firebase (índice de perfis).",
    deleted: "Contas criadas no período que já não estão ativas (apagadas ou desativadas).\nFonte: Firebase (índice de perfis).",
    active: "Utilizadores únicos que usaram a app no período.\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
    newUsers: "Contas criadas no período.\nFonte: Firebase (índice de perfis).",
    engagement: "Tempo médio de uso da app por utilizador ativo, por dia.\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
    retention: "Utilizadores novos do período que voltaram à app 7 dias depois do primeiro dia, mostrado como 1 em cada N.\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
  },
  hints: {
    retention: "ativos após 1 semana",
    shorterThan7: "período inferior a 7 dias",
  },
  minutes: "{value} min",
  engagementValue: "~{value} min",
  retentionValue: "1 em cada {n}",
  modals: {
    complete: {
      title: "Perfis completos",
      subtitle: "Utilizadores com todos os campos de perfil preenchidos",
      bars: "Por faixa etária",
    },
    incomplete: {
      title: "Perfis incompletos",
      subtitle: "Utilizadores com pelo menos um campo de perfil por preencher",
      bars: "Campo em falta",
    },
    deleted: {
      title: "Perfis apagados",
      subtitle: "Contas eliminadas pelo próprio utilizador",
      bars: "Comparativo com os 2 períodos anteriores (mesma duração)",
    },
    active: {title: "Utilizadores ativos", subtitle: "média diária de ativos"},
    newUsers: {title: "Novos utilizadores"},
    engagement: {title: "Engajamento médio", subtitle: "minutos por utilizador ativo"},
    retention: {
      title: "Retenção",
      subtitle: "De cada {n} pessoas que começam a utilizar o VOXGO, só 1 continua ativa depois de 1 semana.",
    },
  },
  missing: {
    cover: "Foto de capa",
    bio: "Biografia",
    avatar: "Foto de avatar",
    birthDate: "Data de nascimento",
    gender: "Género",
  },
  age: {
    under18: "Até 18",
    from18to30: "18 – 30",
    from30to50: "30 – 50",
    over50: "Acima de 50",
    unknown: "Não informado",
  },
  panels: {
    byAge: "Por faixa etária",
    byGender: "Por género",
    byCountry: "Por país",
    others: "Outros",
    map: "Mapa",
  },
  mapTabs: {
    active: "Ativos",
    voxpoints: "VoxPoints",
  },
  panelInfo: {
    map: "Ativos: utilizadores ativos no período por cidade. VoxPoints: VoxPoints ativos no último dia do período.\nFonte: Ativos, Google Analytics (sem ele, Firebase: registo de atividade), com as cidades posicionadas pelo Firebase (lugares dos perfis); VoxPoints, Firebase (VoxPoints).",
    byAge: "Contas registadas no último dia do período por faixa etária.\nFonte: Firebase (contadores de registos).",
    byGender: "Contas registadas no último dia do período por género.\nFonte: Firebase (contadores de registos).",
    byCountry: "Contas registadas no último dia do período por país da morada.\nFonte: Firebase (contadores de registos).",
  },
};
